import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { map, slice, size } from 'lodash';

import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Pagination,
  PaginationItem,
  PaginationLink,
  PopoverBody,
  DropdownToggle,
  Label,
  Input,
} from 'reactstrap';

import { UncontrolledPopover } from 'reactstrap/lib';
import PossibleBotPlayerData from './PossibleBotPlayerData';

import * as constants from '../../../constants/constants';

import {
  getPossibleBotPlayerData,
  getPossibleBotPlayers,
} from '../../../actions/admin';
import DateFormat from '../UI/DateFormat';
import { FORMAT_DATE_TYPE } from '../../../constants/constants';

let carretDown = '\u{25bc}';
let carretUp = '\u{25b2}';

const PossibleBotPlayers = ({ bots, fetchBots, offset }) => {
  const dispatch = useDispatch();
  const [selectedBot, setSelectedBot] = useState('');
  const [openDetailView, setOpenDetailView] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [sortBy, setSortBy] = useState('date');
  const [sortOrder, setSortOrder] = useState('desc');

  const [filterType, setFilterType] = useState('uid');
  const [filter, setFilter] = useState('');


  const pageSize = 50;

  useEffect(() => {
    dispatch(getPossibleBotPlayers(null, null));
    fetchBots();
  }, []);

  useEffect(() => {
    if (selectedBot) {
      dispatch(getPossibleBotPlayerData(selectedBot));
    } else {
      dispatch(getPossibleBotPlayerData(null));
    }
  }, [selectedBot]);

  const possibleBotPlayers = useSelector(state => state.admin.possibleBotPlayers || {});
  const possibleBotPlayerData = useSelector(state => state.admin.possibleBotPlayerData || {});
  const possibleBotLoading = useSelector(state => state.admin.possibleBotLoading || false);
  const pagesCount = possibleBotPlayers ? Math.ceil(Object.keys(possibleBotPlayers).length / pageSize) : 0;

  const toggleSortBy = (type) => {
    if (sortBy === type) {
      if (sortOrder === 'desc') {
        setSortOrder('asc');
      } else {
        setSortOrder('desc');
      }
    } else {
      setSortBy(type);
      setSortOrder('desc');
    }
  };

  const openDetailViewModal = (key) => {
    setOpenDetailView(true);
    setSelectedBot(key);
  };

  const closeDetailViewModal = () => {
    setOpenDetailView(false);
    setSelectedBot('');
  };

  const handleClick = (e, index) => {
    e.preventDefault();

    setCurrentPage(index);
  };

  const selectType = (e) => {
    setFilterType(e.target.value);
  }

  const handleChange = e => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFilter(value);
  }

  const reset = () => {
    setFilter('');
    setFilterType('uid');

    dispatch(getPossibleBotPlayers(null, null));
  }

  const filterUsers = () => {
    console.log('filterfilter', filter, filterType);

    dispatch(getPossibleBotPlayers(filter, filterType));
    // getPossibleBotPlayers(filter, filterType);

    setCurrentPage(0);
  }

  const handleKeyPress = (target) => {
    if (target.charCode === constants.ENTERKEY) {
      filter();
    }
  }

  return (
    <Fragment>
      <UncontrolledPopover popperClassName="popover" placement="right" trigger="focus" target="admin-help-button-possible-bot-players">
        <PopoverBody className="popover-body">
          A list of players who meet at least one of the following: have played in more than 3 rooms per 5 minutes, played more than 5 games per 5 minutes, or played in the auto-play in at least 3 rooms in a row. Can be used to quickly check if the player is not a possible bot account.
        </PopoverBody>
      </UncontrolledPopover>
      <div className="admin-page-content">
        <Row>
          <Col sm="4">
            <h2>
              Possible Bots
              <Button className="admin-help-button" id="admin-help-button-possible-bot-players">
                ?
              </Button>
            </h2>
          </Col>
        </Row>

        <Row>
          <Col sm="2">Search Players</Col>

          <Col sm="10">
            <Row>

              <Col sm="2">
                <Label for="filterType">
                  Search By
                </Label>
                <Input type="select" className="game-bet-select" value={filterType} onChange={selectType}>
                  <option value="name">Name</option>
                  <option value="uid">Player Id</option>
                  <option value="lastIp">Last IP Address</option>

                </Input>
              </Col>

              <Col sm="2">
                <Label for="filter">
                  Value
                </Label>
                <Input
                  type="text"
                  name="filter"
                  id="filter"
                  value={filter}
                  onChange={handleChange}
                  onKeyPress={handleKeyPress}
                />
              </Col>

              <Col sm="2">
                <Button onClick={filterUsers} className="mx-1">
                  Filter
                </Button>
                <Button onClick={reset} className="mx-1">
                  Reset
                </Button>
              </Col>
            </Row>
          </Col>

        </Row>

        <table style={{ width: '100%', fontSize: 12 }}>
          <colgroup>
            <col span="1" className="" />
          </colgroup>
          <thead>
            <tr>
              <th style={{ textAlign: 'center' }} onClick={() => toggleSortBy('date')}>
                Date
                {(sortBy === 'date' ? (`${sortOrder === 'desc' ? (carretUp) : (carretDown)}`) : (null))}

              </th>
              <th style={{ textAlign: 'center' }}>
                Name
              </th>
              <th style={{ textAlign: 'center' }}>
                Player ID
              </th>
              <th style={{ textAlign: 'center' }} onClick={() => toggleSortBy('events')}>
                Events
                {(sortBy === 'events' ? (`${sortOrder === 'desc' ? (carretUp) : (carretDown)}`) : (null))}
                {/*  {sortBy === 'events' ? (<DropdownToggle caret>Events</DropdownToggle>) : (`Events`) } */}
              </th>
              <th style={{ textAlign: 'center' }}>
                View
              </th>
            </tr>
          </thead>
          <tbody>
            {possibleBotLoading ? (
              <Spinner type="grow" color="warning" style={{ width: '2rem', height: '2rem' }} />
            ) : (
              possibleBotPlayers
                && Object.keys(possibleBotPlayers)
                  .sort((a, b) => {
                    if (sortBy === 'events') {
                      if (sortOrder === 'desc') {
                        return (possibleBotPlayers[b].count - possibleBotPlayers[a].count);
                      } else {
                        return (possibleBotPlayers[a].count - possibleBotPlayers[b].count);
                      }
                    } else {
                      if (sortOrder === 'desc') {
                        return (possibleBotPlayers[b].date - possibleBotPlayers[a].date);
                      } else {
                        return (possibleBotPlayers[a].date - possibleBotPlayers[b].date);
                      }
                    }
                    
                  })
                  .slice(currentPage * pageSize, (currentPage + 1) * pageSize)
                  .map((key, idx) => (
                    <tr key={key} className="allUsers-table-row">
                      <td className="allUsers-table-col">
                        <DateFormat formatType={FORMAT_DATE_TYPE.fullDateMinute} date={possibleBotPlayers[key].date + offset} />
                      </td>
                      <td className="allUsers-table-col">
                        {possibleBotPlayers[key].name}
                      </td>
                      <td className="allUsers-table-col">
                        {possibleBotPlayers[key].uid}
                      </td>
                      <td className="allUsers-table-col">
                        {possibleBotPlayers[key].count}
                      </td>
                      <td className="allUsers-table-col">
                        <Button color="warning" onClick={() => openDetailViewModal(key)}>
                          View
                        </Button>
                      </td>
                    </tr>
                  ))
            )}
            {pagesCount && size(possibleBotPlayers) > pageSize && (
              <div className="pagination-wrapper">
                <Pagination aria-label="Page navigation example">
                  <PaginationItem disabled={currentPage === 0}>
                    <PaginationLink style={{ color: '#000' }} onClick={e => handleClick(e, 0)} href="#">
                      {`‹‹‹`}
                    </PaginationLink>
                  </PaginationItem>

                  <PaginationItem disabled={currentPage <= 0}>
                    <PaginationLink
                      style={{ color: '#000' }}
                      onClick={e => handleClick(e, currentPage - 1)}
                      previous
                      href="#"
                    />
                  </PaginationItem>

                  {[...Array(pagesCount)].map((page, i) => {
                    if (i > currentPage - 3 && i < currentPage + 3) {
                      return (
                        <PaginationItem active={i === currentPage} key={page}>
                          <PaginationLink style={{ color: '#000' }} onClick={e => handleClick(e, i)} href="#">
                            {i + 1}
                          </PaginationLink>
                        </PaginationItem>
                      );
                    }

                    return null;
                  })}

                  <PaginationItem disabled={currentPage >= pagesCount - 1}>
                    <PaginationLink
                      style={{ color: '#000' }}
                      onClick={e => handleClick(e, currentPage + 1)}
                      next
                      href="#"
                    />
                  </PaginationItem>

                  <PaginationItem disabled={currentPage >= pagesCount - 1}>
                      <PaginationLink style={{ color: '#000' }} onClick={e => handleClick(e, pagesCount - 1)} href="#">
                        {`›››`}
                      </PaginationLink>
                    </PaginationItem>
                </Pagination>
              </div>
            )}
          </tbody>
        </table>
      </div>
      <Modal container={'div > div'} returnFocusAfterClose={false} size="xlg" isOpen={openDetailView} toggle={closeDetailViewModal}>
        <ModalHeader toggle={closeDetailViewModal}>
          Detail View
        </ModalHeader>
        <ModalBody>
          <PossibleBotPlayerData possibleBotPlayerData={possibleBotPlayerData} bots={bots} offset={offset} />
        </ModalBody>
        <ModalFooter>
          <Button className="modal-footer-button" onClick={() => closeDetailViewModal()}>Close</Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default PossibleBotPlayers;
